// base
import produce from 'immer';

import { createReducer } from 'typesafe-actions';

// action
import {
  FindAction,
  findUserIdAction,
  sendForIdAction,
  sendForPwAction,
  updatePwAction
} from '../actions/findAction';

//
export interface findState {
  idResult: string | undefined;
  userId: string | undefined;
  pwResult: string | undefined;
  udResult: string | undefined;
}
const initFindState : findState = {
  idResult: undefined,
  userId: undefined,
  pwResult: undefined,
  udResult: undefined
}

export const findAccountReducer = createReducer<findState, FindAction>(
  initFindState
).handleAction(sendForIdAction.success, (state, action) => 
  produce(state, draft => {
    const data = action.payload;
    
    draft.idResult = data;
  })
).handleAction(findUserIdAction.success, (state, action) => 
  produce(state, draft => {
    const data = action.payload;

    draft.userId = data;
  })
).handleAction(sendForPwAction.success, (state, action) =>
  produce(state, draft => {
    const data = action.payload;

    draft.pwResult = data;
  })
).handleAction(updatePwAction.success, (state, action) =>
  produce(state, draft => {
    const data = action.payload;

    draft.udResult = data;
  })
)